/**
 * @generated SignedSource<<a980fc20b14fb8f7950e8926bb3eb9bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientPlanSubscriptionStatus = "ACTIVE" | "CANCELED" | "INCOMPLETE" | "INCOMPLETE_EXPIRED" | "PAST_DUE" | "PAUSED" | "TRIALING" | "UNPAID" | "%future added value";
export type ClientSubscriptionPlanNid = "BUILD" | "GROW" | "MEMBERS_ONLY" | "SCALE" | "%future added value";
export type OnboardingType = "CLIENT" | "CONTRACTOR" | "%future added value";
export type UserFeature = "ADD_NOTE_TO_CONTACT_OWN" | "ADD_NOTE_TO_CONTACT_OWN_ORGANIZATION" | "APPLY_TO_JOB" | "APPLY_TO_JOB_POSTING" | "ARCHIVE_JOB_POSTING_ALL" | "ARCHIVE_JOB_POSTING_OWN" | "ARCHIVE_JOB_POSTING_OWNR_TEAM" | "ARCHIVE_JOB_POSTING_OWN_ORGANIZATION" | "AUTOMATICALLY_APPROVE_PAID_PROJECT_INVITE" | "AUTOMATICALLY_MATCH_WITH_CREATED_JOB_POSTINGS" | "AUTOMATICALLY_RATE_PROFILE" | "BLOCK_USERS" | "C4C_REFERRAL_PROGRAM" | "CAN_SYNC_WITH_HUBSPOT" | "CHANGE_ORGANIZATION_MEMBER_ROLE_OWN_ORGANIZATION" | "CHAT_ENABLED" | "CHECK_FOR_INAPPROPRIATE_CONTENT" | "CLAIM_ORGANIZATION" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_FEED_CANNOT_POST" | "COMMUNITY_FEED_CAN_BOOST_SOCIAL_POST" | "COMMUNITY_FEED_CAN_CURATE" | "COMMUNITY_FEED_CAN_DELETE_SOCIAL_POST" | "COMMUNITY_FEED_CAN_FEATURE_SOCIAL_POST" | "COMMUNITY_FEED_CAN_POST" | "COMMUNITY_FEED_CAN_VIEW_FEED" | "CREATE_COMMUNITY_JOB_POSTINGS" | "CREATE_CURATED_PROJECT_LISTS" | "CREATE_JOB_OWN" | "CREATE_JOB_OWN_ORGANIZATION" | "CREATE_JOB_OWN_TEAM" | "CREATE_JOB_POSTING" | "CREATE_JOB_POSTING_OWN" | "CREATE_JOB_POSTING_OWN_ORGANIZATION" | "CREATE_JOB_POSTING_OWN_TEAM" | "CREATE_MANUAL_TEST_USER" | "CREATE_PAID_PROJECT_INQUIRY" | "CREATE_PAID_PROJECT_INVITE" | "DELETE_SOCIAL_POST" | "DELETE_USERS" | "EDIT_CONTACT_OWN" | "EDIT_CONTACT_OWN_ORGANIZATION" | "EDIT_JOB_ALL" | "EDIT_JOB_OWN" | "EDIT_JOB_OWN_ORGANIZATION" | "EDIT_JOB_OWN_TEAM" | "EDIT_JOB_POSTING_DETAILS_ALL" | "EDIT_JOB_POSTING_DETAILS_OWN" | "EDIT_JOB_POSTING_DETAILS_OWN_ORGANIZATION" | "EDIT_JOB_POSTING_DETAILS_OWN_TEAM" | "EDIT_ORGANIZATION_DETAILS_ALL" | "EDIT_ORGANIZATION_DETAILS_OWN_ORGANIZATION" | "ENABLE_CONTRA_FOR_COMPANIES_FOR_ORGANIZATION" | "FAST_FORWARD_CADENCE_CYCLE" | "FEATURE_SOCIAL_POST" | "FRAMER_AD_EXPERIMENT_SHOW_ANALYTICS_TAB_AD" | "FRAMER_AD_EXPERIMENT_SHOW_EXPERT_PAGE_AD" | "FRAMER_AD_EXPERIMENT_SHOW_INDEPENDENT_HOME_AD" | "FRAMER_AD_EXPERIMENT_SHOW_JOBS_PAGE_AD" | "FRAMER_AD_EXPERIMENT_SHOW_PROJECT_CREATION_AD" | "FRAMER_AD_EXPERIMENT_SHOW_SERVICES_CREATION_AD" | "FRAMER_AD_EXPERIMENT_SHOW_SIDE_NAV_AD" | "GENERATE_INTERNAL_SLACK_NOTIFICATIONS" | "HIDE_CONTRACTOR_COMPLETE_PROFILE_CHECKLIST" | "HIDE_FROM_ANALYTICS" | "HIDE_FROM_SEARCH_ENGINES" | "HIDE_FROM_USER_SEARCH" | "HIDE_FROM_USER_SUGGESTIONS" | "IMPERSONATE_USERS" | "IMPORT_PORTFOLIO_PROJECT" | "INDEXABLE_BY_SEARCH_ENGINES" | "INDEXABLE_FOR_USER_SEARCH" | "INSTANT_ACCESS_TO_JOB_POSTINGS" | "INVITE_ORGANIZATION_MEMBER_ROLE_ADMIN_OWN_ORGANIZATION" | "INVITE_ORGANIZATION_MEMBER_ROLE_MEMBER_OWN_ORGANIZATION" | "LIST_ORGANIZATION_MEMBERS_OWN_ORGANIZATION" | "MANAGE_ACH_PAYMENT_REQUESTS" | "MANAGE_BASIC_OPPORTUNITIES" | "MANAGE_DIRECT_PAYMENTS" | "MANAGE_EXCLUSIVE_OPPORTUNITIES" | "MANAGE_HIRING_CREDITS" | "MANAGE_INDEPENDENT_PORTFOLIO_TEMPLATES" | "MANAGE_JOB_BOOST_REQUESTS" | "MANAGE_JOB_POSTINGS" | "MANAGE_JOB_POSTING_APPLICANTS_ALL" | "MANAGE_JOB_POSTING_APPLICANTS_OWN" | "MANAGE_JOB_POSTING_APPLICANTS_OWN_ORGANIZATION" | "MANAGE_JOB_POSTING_APPLICANTS_OWN_TEAM" | "MANAGE_LEDGER_TRANSACTIONS" | "MANAGE_LISTS" | "MANAGE_NOTIFICATIONS" | "MANAGE_ORGANIZATIONS" | "MANAGE_ORGANIZATION_CLAIM_REQUESTS" | "MANAGE_ORGANIZATION_JOIN_REQUEST_FOR_ALL" | "MANAGE_PAID_PROJECTS_ALL" | "MANAGE_PAID_PROJECTS_OWN" | "MANAGE_PAID_PROJECTS_OWN_ORGANIZATION" | "MANAGE_PAID_PROJECTS_OWN_TEAM" | "MANAGE_PAID_PROJECT_INQUIRIES" | "MANAGE_PAYMENT_METHODS_OWN" | "MANAGE_PAYMENT_METHODS_OWN_ORGANIZATION" | "MANAGE_PROFESSIONAL_ROLES" | "MANAGE_PROFESSIONAL_TOOLS" | "MANAGE_THEME_CUSTOMIZATION" | "MANAGE_USER_GROUPS" | "MANAGE_USER_INTERFACE_FLAGS" | "MANAGE_USER_WAITLISTS" | "MANAGE_WORKSPACE_GROUPS" | "MANUAL_LEDGER_ENTRY" | "PROFILE_INTRODUCTION_VIDEO" | "PUBLISH_INDEPENDENT_PORTFOLIO" | "RATE_USERS" | "RECEIVE_EMAILS" | "RECEIVE_INDY_ONBOARDING_WELCOME_EMAILS" | "RECEIVE_PAID_PROJECT_INQUIRY" | "REFERRAL_PROGRAM_MEMBER" | "REQUEST_JOB_POSTING_IMPORT" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN_ORGANIZATION" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_OWN_TEAM" | "REQUIRE_CONTRACT_SIGNATURE" | "RESOLVE_PAID_PROJECT_DISPUTES" | "RESTORE_LEDGER_BALANCE_FOR_FAILED_PAYOUTS" | "SEARCH_COMMUNITY_JOBS" | "SEARCH_TEST_USERS" | "SEARCH_USERS" | "SEND_ARBITRARY_GRAPHQL_REQUESTS" | "SERVICE_INTRODUCTION_VIDEO" | "SET_PROFILE_APPROVAL_STATUS" | "SET_USER_ONBOARDING_TYPE" | "SHARED_NETWORK" | "SHOW_DISCOVER_PROFILE_PREVIEW_CARD" | "SHOW_IN_USER_SEARCH" | "SKIP_AUTOMATED_JOB_POSTING_MATCHING" | "SKIP_AUTO_RATING" | "SKIP_INAPPROPRIATE_CONTENT_CHECK" | "SKIP_SENDING_CHAT_MESSAGES" | "SKIP_SENDING_EMAILS" | "SKIP_SENDING_INTERNAL_SLACK_NOTIFICATIONS" | "SKIP_SIGNING_CONTRACT" | "SOCIAL_REFERRAL_PROGRAM" | "SUBSCRIBE_TO_PORTFOLIOS" | "SYNC_WITH_ANALYTICS" | "USER_DATA_INCLUDED_IN_SUGGESTIONS" | "USE_CLIENT_SHORTCUTS_MENU" | "USE_CONTRACTOR_SHORTCUTS_MENU" | "USE_CRYPTO_SANDBOX" | "USE_EVERSIGN_SANDBOX" | "USE_LEDGER_SANDBOX" | "USE_PAYONEER_SANDBOX" | "USE_PAYPAL_SANDBOX" | "USE_PERSONA_SANDBOX" | "USE_STRIPE_SANDBOX" | "VIEW_INVOICE_ALL" | "VIEW_INVOICE_OWN" | "VIEW_INVOICE_OWN_ORGANIZATION" | "VIEW_INVOICE_OWN_TEAM" | "VIEW_IN_DEVELOPMENT_PORTFOLIO_TEMPLATES" | "VIEW_JOBS_ALL" | "VIEW_JOBS_OWN" | "VIEW_JOBS_OWN_ORGANIZATION" | "VIEW_JOBS_OWN_TEAM" | "VIEW_JOB_FEED" | "VIEW_JOB_POSTINGS_ALL" | "VIEW_JOB_POSTINGS_OWN_ORGANIZATION" | "VIEW_JOB_POSTINGS_OWN_TEAM" | "VIEW_JOB_POSTING_OWN" | "VIEW_PAID_PROJECTS_ALL" | "VIEW_PAID_PROJECTS_OWN" | "VIEW_PAID_PROJECTS_OWN_ORGANIZATION" | "VIEW_PAID_PROJECTS_OWN_TEAM" | "VISUAL_ELECTRIC_ADS_SHOW_ANALYTICS_TAB_AD" | "VISUAL_ELECTRIC_ADS_SHOW_EXPERT_PAGE_AD" | "VISUAL_ELECTRIC_ADS_SHOW_INDEPENDENT_HOME_AD" | "VISUAL_ELECTRIC_ADS_SHOW_JOBS_PAGE_AD" | "VISUAL_ELECTRIC_ADS_SHOW_PROJECT_CREATION_AD" | "VISUAL_ELECTRIC_ADS_SHOW_SERVICES_CREATION_AD" | "VISUAL_ELECTRIC_ADS_SHOW_SIDE_NAV_AD" | "WIX_STUDIO_ADS_SHOW_ANALYTICS_TAB_AD" | "WIX_STUDIO_ADS_SHOW_EXPERT_PAGE_AD" | "WIX_STUDIO_ADS_SHOW_INDEPENDENT_HOME_AD" | "WIX_STUDIO_ADS_SHOW_JOBS_PAGE_AD" | "WIX_STUDIO_ADS_SHOW_PROJECT_CREATION_AD" | "WIX_STUDIO_ADS_SHOW_SERVICES_CREATION_AD" | "WIX_STUDIO_ADS_SHOW_SIDE_NAV_AD" | "%future added value";
export type UserGroup = "ADMIN" | "BLOCKED_USER" | "BOTSTACKS_EXPERT" | "BUBBLE_EXPERT" | "BUILDSHIP_EXPERT" | "C4C_REFERRAL_PROGRAM" | "CLIENT_ONBOARDING_COMPLETE" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_FEED_BANNED_FROM_POSTING" | "COMMUNITY_FEED_CREATOR" | "COMMUNITY_FEED_CURATOR" | "COMMUNITY_FEED_MEMBER" | "COMMUNITY_FEED_VIEWER" | "COMMUNITY_MANAGER" | "CONTRACTOR_ONBOARDING_COMPLETE" | "CONTRACTOR_PROFILE_COMPLETE" | "CONTRA_EXPERT_TEST" | "CONTRA_FOR_COMPANIES_CLIENT" | "CONTRA_PRO_ACCESS_CODE_EVENT" | "CONTRA_PRO_OLD_PRICE_GROUP" | "CONTRA_TEAM_MEMBER" | "CREATOR_PORTFOLIO_EARLY_ACCESS" | "DESCRIPT_EXPERT" | "EXCLUDED_FROM_DISCOVER" | "EXCLUDED_FROM_MATCHING" | "FLAGGED_USER" | "FLAG_FOR_IMPROVEMENT" | "FLUTTERFLOW_EXPERT" | "FRAMER_AD_EXPERIMENT_ANALYTICS_TAB_AUDIENCE" | "FRAMER_AD_EXPERIMENT_EXPERT_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_INDEPENDENT_HOME_AUDIENCE" | "FRAMER_AD_EXPERIMENT_JOBS_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_PROJECT_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SERVICES_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SIDE_NAV_AUDIENCE" | "FRAMER_EXPERT" | "GLORIFY_EXPERT" | "HAS_CUSTOM_EMAIL_DOMAIN" | "HEY_GEN_EXPERT" | "INSTANT_EXPERT" | "INTEGRATION_TEST_USER" | "JITTER_EXPERT" | "JOB_NETWORK_ACCESS_APPROVED" | "KITTL_EXPERT" | "LOTTIEFILES_X_FIGMA_EXPERT" | "LOTTIEFILES_X_FRAMER_EXPERT" | "LOTTIEFILES_X_WEBFLOW_EXPERT" | "LOW_RATED_USER" | "MANUAL_DEMO_USER" | "MANUAL_TEST_USER" | "ORGANIZATION_MEMBER" | "ORGANIZATION_MEMBER_ROLE_ADMIN" | "ORGANIZATION_MEMBER_ROLE_CONTRA_ADMIN" | "PORTFOLIO_DEVELOPER" | "PORTFOLIO_EARLY_ADOPTER" | "QUICK_RESPONDER" | "RELUME_EXPERT" | "REPLO_EXPERT" | "RIVE_EXPERT" | "SOCIAL_FEATURE_ELIGIBLE" | "SPLINE_EXPERT" | "STANDARD_CLIENT" | "TEST_ADMIN" | "TOP_INDEPENDENT_DISCOVERED" | "TOP_INDEPENDENT_OPTED_IN" | "TOP_INDEPENDENT_OPTED_OUT" | "USER_WITH_INQUIRY_AUTO_APPROVAL" | "USER_WITH_INVOICE_AUTO_APPROVAL" | "USER_WITH_JOB_POSTING_AUTO_APPROVAL" | "USER_WITH_PAID_PROJECT_INVITE_AUTO_APPROVAL" | "VISUAL_ELECTRIC_ADS_ANALYTICS_TAB_AUDIENCE" | "VISUAL_ELECTRIC_ADS_EXPERT_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_INDEPENDENT_HOME_AUDIENCE" | "VISUAL_ELECTRIC_ADS_JOBS_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_PROJECT_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SERVICES_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SIDE_NAV_AUDIENCE" | "WEBFLOW_EXPERT" | "WEBSTUDIO_EXPERT" | "WIX_STUDIO_EXPERT" | "WORKSPACE_ADDED_CONTACT" | "%future added value";
export type UserInterfaceFlag = "COMPLETED_FIRST_TIME_PORTFOLIO_TEMPLATE_STORE_EXPERIENCE" | "DOCKED_SIDE_NAVIGATION" | "HIDE_APPBAR_SHARE_BUTTON_SPARKLE_ANIMATION" | "HIDE_BASIC_NETWORK_COLUMN_PREVIEWS" | "HIDE_C4C_AFTER_INVOICE_PAYMENT_PROMO_MODAL" | "HIDE_C4C_REFERRAL_BANNER" | "HIDE_C4C_REFERRAL_TOOLTIP" | "HIDE_CLIENT_COMPLETED_PAID_PROJECT_MODAL" | "HIDE_CLIENT_EDUCATION_COMPLIANT_CONTRACTS_BANNER" | "HIDE_CLIENT_EDUCATION_NETWORK_PAGE_BANNER" | "HIDE_CLIENT_EDUCATION_OPPORTUNITIES_PAGE_BANNER" | "HIDE_CLIENT_EDUCATION_PROJECTS_PAGE_BANNER" | "HIDE_CLIENT_EDUCATION_PROPOSAL_PAGE_BANNER" | "HIDE_CLIENT_FIRST_RECOMMENDATION_TOOLTIP" | "HIDE_CLIENT_HOME_PAGE_HIRE_BANNER" | "HIDE_CLIENT_MESSAGES_TOOLTIP" | "HIDE_CLIENT_OPPORTUNITIES_TOOLTIP" | "HIDE_CLIENT_PROJECTS_TOOLTIP" | "HIDE_CLIENT_SEARCH_PREVIEW_ENDED_MODAL" | "HIDE_CLIENT_SWITCH_MODAL" | "HIDE_CLIENT_WALLET_TOOLTIP" | "HIDE_CLIENT_WELCOME_TO_WORKSPACE_MODAL" | "HIDE_COMMUNITY_CHECKLIST_COMPLETED_SUCCESS_MESSAGE" | "HIDE_COMPLIANCE_OVERVIEW_BANNER" | "HIDE_CONTRACTOR_AND_CLIENT_ONBOARDING_TOUR" | "HIDE_CONTRACTOR_COMPLETED_PAID_PROJECT_MODAL" | "HIDE_CONTRACTOR_FIRST_LIVE_PROJECT_MODAL" | "HIDE_CONTRACTOR_FIRST_RECOMMENDATION_TOOLTIP" | "HIDE_CONTRACTOR_MESSAGES_TOOLTIP" | "HIDE_CONTRACTOR_OPPORTUNITIES_TOOLTIP" | "HIDE_CONTRACTOR_PROJECTS_TOOLTIP" | "HIDE_CONTRACTOR_REFERRAL_BANNER" | "HIDE_CONTRACTOR_SWITCH_MODAL" | "HIDE_CONTRACTOR_WALLET_TOOLTIP" | "HIDE_CONTRA_PRO_FLASH_SALE_BANNER" | "HIDE_CONTRA_PRO_GUIDE_ON_WAITLIST_COMPLETE_PROFILE_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_ON_WAITLIST_EXPLORE_PORTFOLIOS_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_ON_WAITLIST_SHARE_REFERRAL_LINK_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_SUBSCRIBED_WELCOME_TO_CONTRA_PRO_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_UPGRADE_NOW_NOTIFICATION" | "HIDE_CONTRA_PRO_GUIDE_WAITLIST_NOTIFICATION" | "HIDE_CONTRA_PRO_REDEEM_CODE_SUCCESS_BANNER" | "HIDE_CONTRA_PRO_SUBSCRIPTION_STICKY_FOOTER" | "HIDE_CREATOR_TOOLS_AWARD_BANNER" | "HIDE_CUSTOM_PORTFOLIO_EDIT_ON_CONTRA_MODAL" | "HIDE_DASHBOARD_PREVIEW_PORTFOLIO_CTA" | "HIDE_DASHBOARD_VIEW_PORTFOLIO_CTA" | "HIDE_DISCOVERABLE_ON_CONTRA_MODAL" | "HIDE_DISCOVERY_PROFILE_PREVIEW_CARD" | "HIDE_DISCOVER_EDUCATION_CLIENT_BANNER" | "HIDE_DISCOVER_EDUCATION_INDY_BANNER" | "HIDE_DISCOVER_INDY_COMMUNITY_SLACK_INVITE" | "HIDE_DISCOVER_SEARCH_PROFILE_COMPLETE_MODAL" | "HIDE_DISCOVER_SERVICES_INTRO_BANNER" | "HIDE_EDIT_FROM_PORTFOLIO_BANNER" | "HIDE_EXPLORE_CONTRA_PORTFOLIOS_CALLOUT" | "HIDE_FRAMER_AD_EXPERIMENT_ADVERTISEMENT" | "HIDE_FTUE_CLIENT_ACCEPTED_INQUIRY_GUIDED_TOUR" | "HIDE_FTUE_CLIENT_COMPLIANT_CONTRACTS_INFORMATION" | "HIDE_FTUE_CLIENT_CREATED_INQUIRY_MODAL" | "HIDE_FTUE_CLIENT_CREATED_OPPORTUNITY_MODAL" | "HIDE_FTUE_CLIENT_DISCOVER_GUIDED_TOUR" | "HIDE_FTUE_CLIENT_NETWORK_TABLE_GUIDED_TOUR" | "HIDE_FTUE_CLIENT_NEW_JOB_MODAL" | "HIDE_FTUE_CLIENT_OPPORTUNITIES_GUIDED_TOUR" | "HIDE_FTUE_CLIENT_PROJECTS_GUIDED_TOUR" | "HIDE_FTUE_CONTRACTOR_DISCOVER_GUIDED_TOUR" | "HIDE_FTUE_CONTRACTOR_INVITED_TO_COMPANY_MODAL" | "HIDE_FTUE_CONTRACTOR_OPPORTUNITIES_GUIDED_TOUR" | "HIDE_FTUE_CONTRACTOR_PROFILE_GUIDED_TOUR" | "HIDE_FTUE_CONTRACTOR_PROJECTS_GUIDED_TOUR" | "HIDE_FTUE_CONTRA_PROFILE_MAGIC" | "HIDE_FTUE_CONTRA_PROFILE_MAGIC_REVEAL_ANIMATION" | "HIDE_FTUE_CREATED_ITPP_MODAL" | "HIDE_FTUE_CUSTOM_PORTFOLIOS_MODAL" | "HIDE_FTUE_CWA_CUSTOM_PORTFOLIOS_MODAL" | "HIDE_FTUE_DASHBOARD_NEW_ANALYTICS_BANNER" | "HIDE_FTUE_DASHBOARD_NEW_ANALYTICS_MODAL" | "HIDE_FTUE_DASHBOARD_ONBOARDING_EDUCATION_MODAL" | "HIDE_FTUE_DISCOVER_JOBS_COMMUNITY_GUIDELINES_MODAL" | "HIDE_FTUE_INVITE_AND_EARN_MODAL" | "HIDE_FTUE_IP_INCOMPLETE_PREVIEW_MODAL" | "HIDE_FTUE_NEW_INDY_DASHBOARD_WELCOME_MODAL" | "HIDE_FTUE_ONBOARDING_COMPLETED_MODAL" | "HIDE_FTUE_PORTFOLIOS_CUSTOM_DOMAIN_CALLOUT" | "HIDE_FTUE_PORTFOLIOS_TOOLTIP_GUIDE" | "HIDE_FTUE_PORTFOLIOS_UPGRADE_TO_CUSTOMIZE_SIDEBAR_CALLOUT" | "HIDE_FTUE_PROFILE_EXPLORE_PORTFOLIOS_CALLOUT" | "HIDE_FTUE_PROJECTS_PAGE_BRAND_CUSTOMIZATION_CALLOUT" | "HIDE_FTUE_UNLOCK_INDY_JOURNEY_MODAL" | "HIDE_FUTURE_IS_FLEXIBLE_CLIENT_SURVEY_BANNER" | "HIDE_HIRING_EXPERIENCE_EDUCATION_MODAL" | "HIDE_ITPP_ANNOUNCEMENT_BANNER" | "HIDE_ITPP_TOOLTIP" | "HIDE_MESSAGES_UNLOCK_MODAL" | "HIDE_NEW_FEATURES_UNLOCKED_EXPERIENCE" | "HIDE_NEW_OPPORTUNITIES_PAGE_BANNER" | "HIDE_NEW_PROJECTS_PAGE_BANNER" | "HIDE_ONBOARDING_REMINDER_MODAL" | "HIDE_PORTFOLIO_PROJECT_MAGIC_SUGGESTION_TOOLTIP" | "HIDE_PRIMARY_ROLE_CHANGED_WARNING_MODAL" | "HIDE_PRODUCT_HUNT_BANNER" | "HIDE_PRODUCT_HUNT_BANNER_C4C" | "HIDE_PROJECT_GUIDE_CARD" | "HIDE_REFERRAL_BANNER_ON_INVOICE" | "HIDE_REFERRAL_BANNER_ON_PAID_PROJECT" | "HIDE_REFERRAL_BANNER_ON_REQUEST_RECOMMENDATION" | "HIDE_VISUAL_ELECTRIC_ADS_ADVERTISEMENT" | "HIDE_WELCOME_TO_CONTRA_PRO_GUIDE_CHECKLIST_CARD" | "HIDE_WIX_STUDIO_ADS_ADVERTISEMENT" | "SEEN_CONTRA_PRO_GUIDE_CHECKLIST_BOOST_PORTFOLIO_VISIBILITY_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_CHECKLIST_CONNECT_CUSTOM_DOMAIN_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_CHECKLIST_PUBLISH_YOUR_PORTFOLIO_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_CHECKLIST_SHARE_LINK_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_ON_WAITLIST_COMPLETE_PROFILE_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_ON_WAITLIST_EXPLORE_PORTFOLIOS_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_ON_WAITLIST_SHARE_REFERRAL_LINK_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_SUBSCRIBED_WELCOME_TO_CONTRA_PRO_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_UPGRADE_NOW_NOTIFICATION" | "SEEN_CONTRA_PRO_GUIDE_WAITLIST_NOTIFICATION" | "SEEN_CONTRA_PRO_SUBSCRIPTION_MODAL" | "SEEN_FEED_FTUE_MODAL" | "SEEN_JOB_VISIBILITY_MODAL" | "SEEN_PROFILE_MAGIC_MODAL" | "SEEN_WELCOME_TO_YOUR_COMPANY_PROFILE_MODAL" | "STOP_SHOWING_ONBOARDING_CHECKLIST" | "%future added value";
export type WaitListNid = "C4C" | "COMMUNITY_FEED" | "EXPERT_NETWORKS" | "FINANCE_INTEGRATION" | "GROWTH_RECOMMENDATIONS" | "HOURLY_ONGOING_PROJECTS" | "INDEPENDENT_PORTFOLIOS_ALPHA" | "OTHER" | "PRO_ANALYTICS" | "RATE_CALCULATOR" | "SLACK_CLIENT_INTEGRATION" | "%future added value";
export type WorkspaceFeature = "ADVANCED_CONTRACTOR_SEARCH" | "ALLOW_PAYMENT_METHOD_SEPA" | "AUTOMATICALLY_APPROVE_ACH_REQUESTS" | "AUTOMATICALLY_APPROVE_INQUIRIES" | "AUTOMATICALLY_APPROVE_JOB_POSTINGS" | "AUTOMATICALLY_APPROVE_PAID_PROJECT_INVITE" | "BYPASS_COMPLIANT_CONTRACT_PLATFORM_FEES" | "BYPASS_PLATFORM_FEES" | "CLIENT_ACCESS_BASIC_NETWORK" | "CLIENT_ACCESS_NETWORK" | "CLIENT_ANALYTICS" | "CLIENT_COMPLIANT_CONTRACTS" | "CLIENT_CUSTOM_CONTRACTS" | "CLIENT_PUBLISH_NETWORK_LISTS" | "CLIENT_WORKSPACE_DOCUMENT_UPLOAD" | "HAS_ACTIVE_SUBSCRIPTION" | "NO_HOLD_DIRECT_DEBIT_PAYMENTS" | "RESTRICTED_EXPERIENCE" | "SELF_SERVE_SUBSCRIPTION" | "USE_LEDGER_SANDBOX" | "VIEW_CONTRACTOR_COMPLIANCE_DETAILS" | "%future added value";
export type WorkspaceMemberFeature = "ADD_NOTE_TO_CONTACT_FOR_WORKSPACE" | "ARCHIVE_JOB_POSTING_FOR_TEAM" | "ARCHIVE_JOB_POSTING_FOR_WORKSPACE" | "BOOST_JOB_FOR_TEAM" | "BOOST_JOB_FOR_WORKSPACE" | "CHANGE_WORKSPACE_ROLE_FOR_WORKSPACE" | "CREATE_JOB_FOR_TEAM" | "CREATE_JOB_FOR_WORKSPACE" | "CREATE_JOB_POSTING_FOR_TEAM" | "CREATE_JOB_POSTING_FOR_WORKSPACE" | "EDIT_CONTACT_FOR_WORKSPACE" | "EDIT_JOB_FOR_TEAM" | "EDIT_JOB_FOR_WORKSPACE" | "EDIT_JOB_POSTING_DETAILS_FOR_TEAM" | "EDIT_JOB_POSTING_DETAILS_FOR_WORKSPACE" | "EDIT_ORGANIZATION_FOR_WORKSPACE" | "HAS_ACCESS_TO_WORKSPACE" | "INVITE_MEMBER_WITH_ROLE_ADMIN_FOR_WORKSPACE" | "INVITE_MEMBER_WITH_ROLE_MEMBER_FOR_WORKSPACE" | "LIST_WORKSPACE_MEMBERS_FOR_WORKSPACE" | "MANAGE_JOB_POSTING_APPLICANTS_FOR_TEAM" | "MANAGE_JOB_POSTING_APPLICANTS_FOR_WORKSPACE" | "MANAGE_ORGANIZATION_JOIN_REQUEST_FOR_WORKSPACE" | "MANAGE_PAID_PROJECTS_FOR_TEAM" | "MANAGE_PAID_PROJECTS_FOR_WORKSPACE" | "MANAGE_PAYMENT_METHODS_FOR_WORKSPACE" | "MANAGE_SUBSCRIPTION_FOR_WORKSPACE" | "MANAGE_WORKSPACE_DOCUMENTS_FOR_WORKSPACE" | "MANAGE_WORKSPACE_MEMBERSHIPS_FOR_WORKSPACE" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_FOR_TEAM" | "REQUEST_MORE_MATCHES_FOR_JOB_POSTING_FOR_WORKSPACE" | "TRANSFER_JOB_OWNERSHIP_FOR_TEAM" | "TRANSFER_JOB_OWNERSHIP_FOR_WORKSPACE" | "TRANSFER_PAID_PROJECT_OWNERSHIP_FOR_TEAM" | "TRANSFER_PAID_PROJECT_OWNERSHIP_FOR_WORKSPACE" | "VIEW_INVOICE_FOR_TEAM" | "VIEW_INVOICE_FOR_WORKSPACE" | "VIEW_JOBS_FOR_TEAM" | "VIEW_JOBS_FOR_WORKSPACE" | "VIEW_JOB_POSTINGS_FOR_TEAM" | "VIEW_JOB_POSTINGS_FOR_WORKSPACE" | "VIEW_PAID_PROJECTS_FOR_TEAM" | "VIEW_PAID_PROJECTS_FOR_WORKSPACE" | "VIEW_TRANSACTION_HISTORY_FOR_TEAM" | "VIEW_TRANSACTION_HISTORY_FOR_WORKSPACE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CurrentUser$data = {
  readonly analyticsUserId: string;
  readonly calendarLink: string | null;
  readonly createdAt: ContraAPIScalars.DateTime;
  readonly emailAddress: string | null;
  readonly id: string;
  readonly intercomUserHash: string;
  readonly isTestAccount: boolean;
  readonly posthogId: string;
  readonly profile: {
    readonly analytics: {
      readonly id: string;
    } | null;
    readonly analyticsId: number;
    readonly avatarImage: {
      readonly id: string;
      readonly uid: string;
      readonly url: string;
    } | null;
    readonly bio: string | null;
    readonly displayUsername: string;
    readonly firstName: string | null;
    readonly hasActivePortfolioSubscription: boolean;
    readonly id: string;
    readonly independentPortfolioTemplateTheme: {
      readonly id: string;
    } | null;
    readonly isRemovedFromClientWorkspace: boolean;
    readonly lastName: string | null;
    readonly location: string | null;
    readonly locationGooglePlaceId: string | null;
    readonly membershipRequestedAt: ContraAPIScalars.Date | null;
    readonly onboardingType: OnboardingType;
    readonly organizationV2: {
      readonly id: string;
      readonly name: string;
      readonly slug: string | null;
    } | null;
    readonly professionalTitle: string | null;
    readonly title: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"AvatarImageFragment">;
  };
  readonly selectedUserType: OnboardingType;
  readonly signupSource: string | null;
  readonly userFeatures: ReadonlyArray<UserFeature>;
  readonly userGroups: ReadonlyArray<UserGroup>;
  readonly userInterfaceFlags: ReadonlyArray<UserInterfaceFlag>;
  readonly waitLists: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly nid: WaitListNid;
      };
    }>;
  };
  readonly workspaceForSelectedUserType: {
    readonly __typename: string;
    readonly activeSubscription?: {
      readonly createdAt: ContraAPIScalars.DateTime | null;
      readonly nid: ClientSubscriptionPlanNid;
      readonly status: ClientPlanSubscriptionStatus;
      readonly trialRemainingDays: number | null;
    } | null;
    readonly clientMembershipRequest?: {
      readonly advancedSearchPreviewStartedAt: ContraAPIScalars.DateTime | null;
      readonly hasRequestedAdvancedSearchPreview: boolean;
      readonly hasRequestedMembership: boolean;
      readonly hasScheduledACall: boolean;
    } | null;
    readonly enabledFeatures: ReadonlyArray<WorkspaceFeature>;
    readonly id: string;
    readonly members: {
      readonly count: number;
    };
    readonly name: string;
    readonly visitorMember: {
      readonly enabledFeatures: ReadonlyArray<WorkspaceMemberFeature>;
      readonly id: string;
    } | null;
  };
  readonly workspaces: ReadonlyArray<{
    readonly __typename: string;
    readonly visitorMember: {
      readonly enabledFeatures: ReadonlyArray<WorkspaceMemberFeature>;
    } | null;
  }>;
  readonly " $fragmentType": "CurrentUser";
};
export type CurrentUser$key = {
  readonly " $data"?: CurrentUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurrentUser">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v0/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nid",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabledFeatures",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrentUser",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "calendarLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "posthogId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestAccount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedUserType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signupSource",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "intercomUserHash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userInterfaceFlags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "membershipRequestedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organizationV2",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationGooglePlaceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "location",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraImage",
          "kind": "LinkedField",
          "name": "avatarImage",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isRemovedFromClientWorkspace",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bio",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUsername",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onboardingType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "professionalTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "analyticsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IndependentPortfolioTemplateTheme",
          "kind": "LinkedField",
          "name": "independentPortfolioTemplateTheme",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserProfileAnalytics",
          "kind": "LinkedField",
          "name": "analytics",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasActivePortfolioSubscription",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AvatarImageFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userFeatures",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userGroups",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WaitListConnection",
      "kind": "LinkedField",
      "name": "waitLists",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WaitListEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WaitList",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "workspaceForSelectedUserType",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v0/*: any*/),
        (v6/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "visitorMember",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v6/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkspaceMemberConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientMembershipRequest",
              "kind": "LinkedField",
              "name": "clientMembershipRequest",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasRequestedMembership",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "advancedSearchPreviewStartedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasRequestedAdvancedSearchPreview",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasScheduledACall",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientWorkspaceSubscription",
              "kind": "LinkedField",
              "name": "activeSubscription",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "trialRemainingDays",
                  "storageKey": null
                },
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ClientWorkspace",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "workspaces",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "visitorMember",
          "plural": false,
          "selections": [
            (v6/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserAccount",
  "abstractKey": null
};
})();

(node as any).hash = "33531113cf39f863e38b48721c9850b6";

export default node;
